var DialogView = require('dialogview');
var util = require('../lib/util.es6');


var NoAuthDialogView = DialogView.extend({
    el: '#noAuth',
    closeOnEsc: false,
    initialize: function (options) {
        this.init();
        
        this.router = options.router;
        this.router.bind('route', this.onRoute, this);
        this.router.route('?/password-reset', 'passwordReset', _.bind(this.showForgotPassword, this));
        this.router.route('?/error=:error', 'showError', _.bind(this.showError, this));
        this.router.route('?/team-error=:error', 'showError', _.bind(this.showError, this));
        this.router.route('?/account-deleted', 'showAccountDeleted', _.bind(this.showAccountDeleted, this));
        this.router.route('?/invite=:key&email=:email', 'fillSignup', _.bind(this.fillSignup, this));
        this.router.route('?/invite=:key&email=:email&url=*url', 'fillSignup', _.bind(this.fillSignup, this));
        
        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit form.signin': 'signIn',
        'submit form.signupForm': 'signUp',
        'submit form.forgotPasswordForm': 'forgotPassword',
        'click .aboutReveal': 'clickAboutReveal',
        'click .signinReveal': 'clickSigninReveal',
        'click .noAuthAbout .noAuthOverlayClose': 'clickAboutClose',
        'click .noAuthSignin .noAuthOverlayClose': 'clickSigninClose',
        'click .noAuthForgotPassword .noAuthOverlayClose': 'clickForgotClose',
        'click .noAuthShade': 'clickShade'
    }),
    init: function () {
        this.$('form.signupForm').show();
        this.hideOverlays();
        
        this.$('.signupInfo').hide();
        this.$('.signupInfo.none').show();
        this.$('.accountDeleted').hide();
        this.$('.noAuthSignupNick').hide();
        this.$('.inviteEmail').hide();
        this.$('.noAuthSignupEmail').show();
    },  
    onRoute: function (route, args) {
        if (!this.model.isAuthed()) {
            if (!_.include(['passwordReset'], route)) {
                this.hideForgot();
            }
        }
    },
    showError: function (error) {
        var msg;
        switch (error) {
        case 'invalid_invite':
            msg = 'Invalid invite key';
            break;
        case "redeemed_elsewhere":
            msg = "This invite has already been used";
            break;
        case "org_deleted":
            msg = "This team has been deleted";
            break;
        case "invite_revoked":
            msg = "This invite has been revoked";
            break;
        default:
            msg = 'An error occurred';
            break;
        }
        this.$('.urlError').text(msg).fadeIn('fast');
    },
    showAccountDeleted: function () {
        this.$('.accountDeleted').fadeIn('fast');
    },
    clickAboutReveal: function (e) {
        e.preventDefault();
        this.$('.noAuthAbout, .noAuthShade').show();
        setTimeout(_.bind(function () {
            this.$el.addClass('showAbout');
        }, this), 0);
    },
    clickAboutClose: function (e) {
        e.preventDefault();
        this.$('.noAuthAbout, .noAuthShade').hide();
        this.$el.removeClass('showAbout');
    },
    clickSigninReveal: function (e) {
        e.preventDefault();
        this.$('.noAuthSignin, .noAuthShade').show();
        this.focusLoginEmail();
        setTimeout(_.bind(function () {
            this.$el.addClass('showSignin');
        }, this), 0);
    },
    clickSigninClose: function (e) {
        e.preventDefault();
        this.$('.noAuthSignin, .noAuthShade').hide();
        this.$el.removeClass('showSignin');
    },
    clickShade: function (e) {
        e.preventDefault();
        this.hideOverlays();
    },
    showForgotPassword: function () {
        this.$('.noAuthForgotPassword, .noAuthShade').show();
        this.$('#noAuthForgotEmail').val(this.$('#noAuthSigninEmail').val());
        this.focusForgotPasswordEmail();
        setTimeout(_.bind(function () {
            this.$el.addClass('showForgot').removeClass('showSignin').removeClass('showAbout');
        }, this), 0);
    },
    clickForgotClose: function (e) {
        e.preventDefault();
        this.hideForgot();
    },
    hideForgot: function () {
        if (this.$el.hasClass('showForgot')) {
            this.model.back();
            this.$('.noAuthForgotPassword, .noAuthShade').hide();
            this.$el.removeClass('showForgot');
        }
    },
    hideOverlays: function () {
        this.hideForgot();
        this.$('.noAuthOverlay, .noAuthShade').hide();
        this.$el.removeClass('showSignin').removeClass('showAbout');
    },
    fillSignupNetwork: function (url) {
        var bufferParts = util.getBufferParts(url);
        var legacyBufferParts = util.getBufferPartsLegacy(
            url, Backbone.history.getHash()
        );
        if (legacyBufferParts) {
            if (
                !bufferParts ||
                !bufferParts.hostname ||
                (!bufferParts.buffer && legacyBufferParts.buffer)
            ) {
                bufferParts = legacyBufferParts;
            }
        }
        this.$('[name=invite_url]').val(url);
        this.$('.signupInfo').hide();
        if (bufferParts && bufferParts.hostname) {
            if (bufferParts.buffer) {
                this.$('.signupInfo .channel').text(bufferParts.buffer);
                this.$('.signupInfo .network').text(bufferParts.hostname);
                this.$('.signupInfo.channel').show();
            } else {
                this.$('.signupInfo .network').text(bufferParts.hostname);
                this.$('.signupInfo.network').show();
            }
            this.$('.noAuthSignupNick').show();
        }
    },
    fillOrgSignup: function (key, email, orgName) {
        this.$('[name=org_invite]').val(key);
        this.$('.signupInfo .org').text(decodeURIComponent(orgName));
        this.$('.signupInfo.org').show();
        this.fillSignup('', email);
    },
    fillSignup: function (key, email, url) {
        if (this.model.isAuthed()) {
            if (url) {
                this.model.trigger('navigate', 'irc/' + url, {replace: true, trigger: true});
            } else {
                this.model.trigger('startFallback');
            }
        } else {
            if (url) {
                this.fillSignupNetwork(url);
            }
            this.$('.noAuthSignupEmail').hide();
            this.$('#noAuthSignupEmail').prop('disabled', true);
            this.$('#noAuthSignupEmailHidden').prop('disabled', false);
            
            email = decodeURIComponent(email);
            var emailParts = email.split('@');
            var nick = emailParts[0].replace(NoAuthDialogView.VALID_NICK_RE, '');
            if (nick.match(/^\d/)) {
                nick = 'user_' + nick;
            }
            this.$('#noAuthSignupNick').val(nick);
            
            this.$('.accountEmail').text(email);
            this.$('[name=signup_email]').val(email);
            this.$('[name=email]').val(email);
            this.$('.inviteEmail').show();
            this.$('[name=invite]').val(key);
        }
    },
    afterShow: function () {
        this.focusSignupNick();
        this.renderImages();
    },
    renderImages: function () {
        if (!this.renderImagesDone) {
            this.renderImagesDone = true;
            var devices = this.$('.mobileDevices');
            devices.append($('<img>')
                .attr('src', window.IRCConfig.static_path + '/landing/imgs/ipad.png')
                .addClass('mobileIpad')
            );
            devices.append($('<img>')
                .attr('src', window.IRCConfig.static_path + '/landing/imgs/iphone.png')
                .addClass('mobileIphone')
            );
            devices.append($('<img>')
                .attr('src', window.IRCConfig.static_path + '/landing/imgs/android.png')
                .addClass('mobileAndroid')
            );
        }
    },
    focusSignupNick: function () {
        this.$('#noAuthSignupNick').focus().select();
    },
    focusLoginEmail: function () {
        this.$('#noAuthSigninEmail').focus().select();
    },
    focusForgotPasswordEmail: function () {
        this.$('#noAuthForgotEmail').focus().select();
    },
    isValidNick: function (nick) {
        if (nick.length > 30) {
            return false;
        }
        if (nick.match(/^[0-9-]/)) {
            return false;
        }
        if (nick.match(NoAuthDialogView.VALID_NICK_RE)) {
            return false;
        }
        return true;
    },
    forgotPassword: function (e) {
        e.preventDefault();
        var form = $(e.target);
        form.find('.userError').hide();
        form.find('.userSuccess').hide();
        var email = this.$('#noAuthForgotEmail').val();
        this.model.forgotPassword(email, _.bind(function (response) {
            if (response.success) {
                form.find('.userSuccess').fadeIn('fast');
            } else {
                var msg;
                switch (response.message) {
                case 'email':
                    msg = 'Invalid email address';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                default:
                    msg = 'Error sending password reset';
                }
                form.find('.userError').text(msg).fadeIn('fast');
            }
        }, this));
    },
    signUp: function (e) {
        e.preventDefault();
        var form = $(e.target);
        form.find('.userError').hide();
        var formData = form.serializeForm();
        var data = {
            email: formData.signup_email,
            password: formData.signup_password,
            realname: formData.signup_realname,
            invite: formData.invite,
            org_invite: formData.org_invite,
            invite_url: formData.invite_url
        };
        if (form.find('.noAuthSignupNick').is(':visible')) {
            var nick = form.find('#noAuthSignupNick').val();
            if (!nick) {
                form.find('.nickMissing').fadeIn('fast');
                return;
            }
            if (!this.isValidNick(nick)) {
                form.find('.nickInvalid').fadeIn('fast');
                return;
            }
            data.nickname = nick;
        }
        form.addSpin();
        this.model.signup(data, _.bind(function (response) {
            form.removeSpin();
            if (response.success) {
                this.startSession(response, formData.invite_url);
                this.hide();
            } else {
                var msg;
                switch (response.message) {
                case 'missing_nick':
                    form.find('.nickMissing').fadeIn('fast');
                    break;
                case 'invalid_nick':
                    form.find('.nickInvalid').fadeIn('fast');
                    break;
                case 'email':
                    msg = 'Invalid email address';
                    break;
                case 'email_exists':
                    msg = 'This email address is already in use, please sign in or try another';
                    break;
                case 'invalid_invite':
                    msg = 'Invalid invite key';
                    break;
                case 'password':
                    msg = 'Invalid password';
                    break;
                case "password_too_long":
                    msg = 'Maximum password length: ' + window.IRCConfig.max_password_length;
                    break;
                case "password_error":
                    msg = 'Invalid password, try again';
                    break;
                case 'realname':
                    form.find('.realnameInvalid').fadeIn('fast');
                    break;
                case 'banned':
                    msg = 'Signup server unavailable, please try again later';
                    break;
                case 'bad_email':
                    msg = 'No signups allowed from that domain';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                case 'rate_limited':
                    msg = 'Too many signups from your IP. Try again later.';
                    break;
                case 'ip_banned':
                    msg = 'Signup server unavailable, please try again later';
                    break;
                case 'tor_blocked':
                    msg = 'No signups allowed from TOR exit nodes';
                    break;
                case 'signup_ip_blocked':
                    msg = 'Your IP address has been blacklisted';
                    break;
                default:
                    msg = 'Error signing up your account: ' + response.message;
                    break;
                }
                if (msg) {
                    form.find('.signupError').text(msg).fadeIn('fast');
                }
            }
        }, this));
    },
    startSession: function (response, inviteUrl) {
        window.WS_SOCKET_HOST = response.websocket_host;
        window.WS_SOCKET_PATH = response.websocket_path;
        window.API_HOST = response.api_host;
        var url = response.url;
        if (!url && inviteUrl) {
            url = 'irc/' + inviteUrl;
        }
        this.model.startSession(response.session, url);
    },
    signIn: function (e) {
        e.preventDefault();
        var form = $(e.target);
        form.find('.userError').hide();
        var inviteUrl = form.find('[name=invite_url]').val();
        form.addSpin();
        this.model.signin({
            email: form.find('[name=email]').val(),
            password: form.find('[name=password]').val(),
            invite_url: inviteUrl
        }, _.bind(function (response) {
            form.removeSpin();
            if (response.success) {
                this.startSession(response, inviteUrl);
            } else {
                var msg;
                switch (response.message) {
                case "auth":
                    msg = 'Incorrect email or password';
                    break;
                case "email":
                    msg = 'Email left blank';
                    break;
                case "password":
                    msg = 'Password left blank';
                    break;
                case "rate_limited":
                    msg = 'Rate limited, try again in a few mins';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                case "email_exists":
                    msg = 'An account with this email already exists';
                    break;
                case "password_too_long":
                    msg = 'Maximum password length: ' + window.IRCConfig.max_password_length;
                    break;
                case "password_error":
                    msg = 'Invalid password, try again';
                    break;
                case "external_failed":
                    msg = 'Authentication server error';
                    break;
                default:
                    msg = 'Error signing in';
                    break;
                }
                form.find('.signinError').text(msg).fadeIn('fast');
            }
        }, this));
    }
}, {
    VALID_NICK_RE: /[^a-z0-9_\\[\]{}^`|-]/gi
});


module.exports = NoAuthDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/noauthdialogview.js
// module id = /Wd8
// module chunks = 1